import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const SuperAdminRoleIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <path
                d="M12 22C12 22 20 18 20 12V5.00002L12 2.00002L4 5.00002V12C4 18 12 22 12 22Z"
                fill="none"
                stroke={props.htmlColor || '#21272E'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.2813 8.95632H15.8687C15.8207 7.20916 14.276 5.94141 12.0601 5.94141C9.87078 5.94141 8.19287 7.19318 8.19287 9.07351C8.19287 10.5916 9.27952 11.4812 11.032 11.9553L12.3211 12.3068C13.4876 12.6158 14.3878 12.9993 14.3878 13.9688C14.3878 15.0341 13.3704 15.7372 11.9695 15.7372C10.7017 15.7372 9.64706 15.1726 9.55118 13.9847H7.8999C8.00644 15.9609 9.5352 17.1808 11.9802 17.1808C14.5423 17.1808 16.0178 15.8331 16.0178 13.9847C16.0178 12.0192 14.2653 11.2575 12.8804 10.9165L11.815 10.6396C10.9628 10.4212 9.82817 10.0217 9.8335 8.97763C9.8335 8.05078 10.6804 7.36364 12.0228 7.36364C13.2745 7.36364 14.1641 7.94957 14.2813 8.95632Z"
                fill={props.htmlColor || '#21272E'}
            />
        </SvgIcon>
    );
};
